"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.GenericCRUD = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _ = require(".");

var GenericCRUD = /*#__PURE__*/function () {
  function GenericCRUD(_ref) {
    var client = _ref.client,
        path = _ref.path,
        idField = _ref.idField;
    (0, _defineProperty2.default)(this, "client", void 0);
    (0, _defineProperty2.default)(this, "path", void 0);
    (0, _defineProperty2.default)(this, "idField", void 0);
    this.client = client;
    this.path = path;
    this.idField = idField;
  }

  var _proto = GenericCRUD.prototype;

  _proto.getAll = function getAll(item, search) {
    return (0, _.getAll)({
      client: this.client,
      path: this.path
    }, item, search);
  };

  _proto.getById = function getById(id) {
    return (0, _.getById)({
      client: this.client,
      path: this.path,
      id: id
    });
  };

  _proto.deleteItem = function deleteItem(id) {
    return (0, _.deleteItem)({
      client: this.client,
      path: this.path,
      id: id
    });
  };

  _proto.create = function create(item) {
    return (0, _.create)({
      client: this.client,
      path: this.path
    }, item, this.idField);
  };

  _proto.update = function update(item, id) {
    return (0, _.update)({
      client: this.client,
      path: this.path,
      id: id
    }, item);
  };

  _proto.patch = function patch(item, id) {
    return (0, _.patch)({
      client: this.client,
      path: this.path,
      id: id
    }, item);
  };

  return GenericCRUD;
}();

exports.GenericCRUD = GenericCRUD;